<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;申請</span>
        </div>
        <div class="card-body">
          <form novalidate #notificationForm="ngForm" class="col-md-12" (ngSubmit)="save()">
            <div style="height: 1px"></div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3 row">
                  <div class="col-md-4"><span>現在の支払方法：</span></div>
                  <div class="form-group col-md-8">
                    @if (member.payment?.paymentMethod == 0) { <span>口座振替</span> }
                    @if (member.payment?.paymentMethod == 1) { <span>クレジットカード</span> }
                  </div>
                </div>
              </div>
            </div>
            <strong>支払方法変更申請</strong>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">支払方法</label>
                    <select class="form-control" [(ngModel)]="select.singlePayment.paymentMethod" name="paymentMethod" required>
                      <option [ngValue]="null">選択してください</option>
                      @if (btPaymentEnabledMypage == 1) { <option [ngValue]="0">口座振替</option> }
                      <option [ngValue]="1">クレジットカード</option>
                    </select>
                  </div>
                  @if (select.singlePayment.paymentMethod == '0' && btPaymentEnabledMypage == 1) {
                    <div class="col-md-12">
                      <p class="text-muted mt-2 mb-0">「オンライン口座登録」ボタンを押すと、オンライン口座登録画面に遷移します。そちらで口座情報の登録手続きを行ってください。</p>
                    </div>
                  }
                  @if (select.singlePayment.paymentMethod == '1') {
                    <label class="col-md-12 col-form-label">クレジットカード番号</label>
                    <div class="col-md-6">
                      <input type="text" class="form-control" [(ngModel)]="select.getGmo.CardNo" name="CardNo" placeholder="クレジットカード番号を半角数字で入力" required minlength="14" sfMaxLength="16" sfNumericOnly inputmode="numeric">
                    </div>
                    <label class="col-md-12 col-form-label">クレジットカード名義</label>
                    <div class="col-md-6">
                      <input type="text" class="form-control" [(ngModel)]="select.getGmo.HolderName" name="HolderName" placeholder="例：SMART TARO" required>
                    </div>
                    <label class="col-md-12 col-form-label">クレジットカード有効期限</label>
                    <div class="col-md-2">
                      <select class="form-control" [(ngModel)]="select.getGmo.expireMonthAt" name="expireMonth" required>
                        <option value="">月</option>
                        @for (m of cc_expire_months; track m) { <option [value]="m">{{ m }}</option> }
                      </select>
                    </div>
                    <label class="col-md-1 col-form-label">月</label>
                    <div class="col-md-2">
                      <select class="form-control" [(ngModel)]="select.getGmo.expireYearAt" name="expireYear" required>
                        <option value="">年</option>
                        @for (y of cc_expire_years; track y) { <option [value]="y">{{ y }}</option> }
                      </select>
                    </div>
                    <label class="col-md-1 col-form-label">年</label>
                    <label class="col-md-12 col-form-label">クレジットカードセキュリティコード</label>
                    <div class="col-md-6">
                      <input type="text" class="form-control" [(ngModel)]="select.getGmo.security" name="security" placeholder="セキュリティコードを半角数字で入力" required sfMaxLength="4" sfNumericOnly inputmode="numeric">
                    </div>
                  }
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">支払方法の適用日：
                      @if (select.singlePayment.paymentMethod == '0') { <span>{{ formatDate(nextPaymentDateBt, 'yyyy年MM月') }}末</span> }
                      @if (select.singlePayment.paymentMethod == '1') { <span>{{ formatDate(nextPaymentDateCc, 'yyyy年MM月dd日') }}</span> }
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br /><br />
            <div class="row">
              <div class="d-none d-sm-flex col-md-12 justify-content-end flex-wrap" style="gap: 0.5rem;">
                <button type="button" routerLink="/notification" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
                @if (select.singlePayment.paymentMethod == '0' && btPaymentEnabledMypage == 1) {
                  <button type="button" class="btn btn-info text-white" [disabled]="btPostLoading" (click)="openBtRegistration()"><i class="fa s-icon-link"></i>&nbsp;オンライン口座登録</button>
                } @else {
                  <button type="submit" class="btn btn-success" [disabled]="notificationForm.invalid || isButtonDisable"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
                }
              </div>
              <div class="d-block d-sm-none col-12">
                @if (select.singlePayment.paymentMethod == '0' && btPaymentEnabledMypage == 1) {
                  <button type="button" class="btn btn-info text-white col-12 form-group" [disabled]="btPostLoading" (click)="openBtRegistration()"><i class="fa s-icon-link"></i>&nbsp;オンライン口座登録</button>
                } @else {
                  <button type="submit" class="btn btn-success col-12 form-group" [disabled]="notificationForm.invalid || isButtonDisable"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
                }
                <button type="button" routerLink="/notification" class="btn bg-close text-white col-12 form-group"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
